import { useEffect, useRef } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { acquisitionHint, analyticsAllowed, ATTRIBUTION_KEY, readAttribution } from '@/lib/growth/attribution';

// Memory only until analytics consent. Mount once, outside route suspense.
const entry = typeof window === 'undefined' || ['/auth/callback','/reset-password','/email-preferences','/unsubscribe'].includes(window.location.pathname) ? null : acquisitionHint(window.location.href, document.referrer);
export function AcquisitionCapture() {
  const { user } = useAuth();
  const firstAccount = useRef<string | null>(null);
  useEffect(() => {
    let disposed = false;
    const capture = async () => {
      try {
        if (user?.id && firstAccount.current && firstAccount.current !== user.id) { sessionStorage.removeItem(ATTRIBUTION_KEY); return; }
        if (user?.id) firstAccount.current = user.id;
        if (!analyticsAllowed(localStorage)) { sessionStorage.removeItem(ATTRIBUTION_KEY); return; }
        let hint = readAttribution(sessionStorage);
        if (!hint && entry) { hint = entry; sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(hint)); }
        if (!hint || !user?.id || !user.email_confirmed_at || user.is_anonymous) return;
        // No user id is accepted by the RPC. The server derives the verified caller.
        const { error } = await supabase.rpc('record_signup_attribution' as never, { _hint: hint, _analytics_consent: true } as never);
        if (!disposed && !error) sessionStorage.removeItem(ATTRIBUTION_KEY);
      } catch { /* Attribution must never interrupt signup or log visitor data. */ }
    };
    void capture();
    window.addEventListener('gg:consent-changed', capture);
    window.addEventListener('storage', capture);
    return () => { disposed = true; window.removeEventListener('gg:consent-changed', capture); window.removeEventListener('storage', capture); };
  }, [user?.id, user?.email_confirmed_at, user?.is_anonymous]);
  return null;
}
